import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const IOS_URL = 'https://apple.co/44ajr0e';
const ANDROID_URL =
  'https://play.google.com/store/apps/details?id=com.quisqueyaquest.mobile&hl=en';

function StorePage() {
  const history = useHistory();

  useEffect(() => {
    const ua = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/i.test(ua);
    const isAndroid = /Android/i.test(ua);

    if (isIOS) {
      window.location.href = IOS_URL;
    } else if (isAndroid) {
      window.location.href = ANDROID_URL;
    }

    // On mobile: the OS intercepts the store URL and opens the app while the browser
    // tab stays open — the timeout fires and sends the tab to the welcome page.
    // On desktop: no store redirect fired, so this runs immediately.
    const delay = isIOS || isAndroid ? 500 : 0;
    const timer = setTimeout(() => history.replace('/welcome'), delay);
    return () => clearTimeout(timer);
  }, [history]);

  return null;
}

export default StorePage;
